<script setup lang="ts">
import type { IllustrationName } from './types'

type Props = {
  name: IllustrationName
  width?: number | string
  height?: number | string
  alt?: string
}

const props = withDefaults(defineProps<Props>(), {
  width: 600,
  height: 600,
  alt: '',
})

const source = computed(() => `/images/${props.name}.webp`)
</script>

<template>
  <img
    class="the-illustration"
    data-test-id="illustration-image"
    :src="source"
    :alt="alt"
    :width="width"
    :height="height"
    loading="lazy"
  />
</template>
